<template>
    <div class="nav-content-wrapper" v-if="!$store.state.waitingRequest">
        <admin-navbar />
        
        <div class="content">
            <h2>Modification du compte "{{ login }}"</h2>

            <form action="" method="POST" @submit.prevent="validation">
                <p v-if="loginError">{{ loginError }}</p>
                <label>Identifiant</label>
                <input type="text" :value="login" @input="login= $event.target.value" @focus="loginErrors" @keyup="loginErrors" :class="{ border: loginError }" />
                
                <p v-if="passwordError">{{ passwordError }}</p>
                <label>Mot de passe</label>
                <input type="text" :value="password" @input="password= $event.target.value" @focus="passwordErrors" @keyup="passwordErrors" :class="{ border: passwordError }" />

                <p v-if="emailError">{{ emailError }}</p>
                <label>Adresse e-mail</label>
                <input type="text" :value="email" @input="email= $event.target.value" @focus="emailErrors" @keyup="emailErrors" :class="{ border: emailError }" />
                
                <label>Rôle</label>
                <select v-model="role">
                    <option value="0">Membre</option>
                    <option value="1">Administrateur</option>
                    <option value="2">Modérateur</option>
                    <option value="3">Game manager</option>
                </select>

                <input type="submit" value="Modifier" />

                <p v-if="alert">{{ alert }}</p>
            </form>
        </div>
    </div>
</template>

<script>
    import Session from '../mixins/adminSession';
    import AdminNavbar from '../views/AdminNavbar';

    export default {
        name: "AdminEditAccount",
        mixins: [Session],
        components: {
            'admin-navbar': AdminNavbar
        },
        data() {
            return {
                id: '',
                login: '',
                email: '',
                role: '',

                loginError: '',
                passwordError: '',
                emailError: '',

                password: '',

                alert: '',
            }
        },
        mounted() {
            this.getAccount();
        },
        methods: {
            getAccount() {
                let formData = new FormData();
                formData.append('data', JSON.stringify({
                    post: "1",
                    accountId: this.$route.params.accountId
                }));

                axios.post(this.$store.state.apiUrl+"?request=getAccount", formData)
                .then((response) => {
                    if(response.data.id) {
                        this.id = response.data.id;
                        this.login = response.data.identifiant;
                        this.email = response.data.mail;
                        this.role = response.data.role;
                    }
                    else {
                        this.$router.replace('../editAccounts');
                    }
                });
            },
            validation() {
                
            }
        }
    }
</script>

<style scoped src="@/assets/admin.css">
</style>
